import React, { useState, useContext, useEffect } from "react";
import CssBaseline from "@material-ui/core/CssBaseline";
import { makeStyles } from "@material-ui/core/styles";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import Container from "@material-ui/core/Container";
import Paper from "@material-ui/core/Paper";
import { isMobile } from "react-device-detect";
import Typography from "@material-ui/core/Typography";
import Grid from "@material-ui/core/Grid";
import moment from "moment";
import _ from "lodash";
import IconButton from "@material-ui/core/IconButton";
import Tooltip from "@material-ui/core/Tooltip";
import CachedIcon from "@material-ui/icons/Cached";
import { ShopperContext } from "../contexts";

const useStyles = makeStyles((theme) => ({
  root: {
    width: "100%",
    maxWidth: 360,
    backgroundColor: theme.palette.background.paper,
  },
  paper: {
    marginTop: isMobile ? theme.spacing(2) : theme.spacing(1),
    padding: isMobile ? theme.spacing(2) : theme.spacing(4),
  },
  records: {
    marginTop: isMobile ? theme.spacing(4) : theme.spacing(4),
  },
}));

export default function Components({ data }) {
  const { state, setState } = useContext(ShopperContext);
  const classes = useStyles();
  const [initialState, setInitialState] = useState(
    data ? (data.ManuelConfirms ? data.ManuelConfirms : {}) : {}
  );
  const { queryLog } = initialState;
  const [inquiry, setInquiry] = useState([]);

  function createData(name, value) {
    return { name, value };
  }

  const handleClick = () => {
    setInitialState({});
    setState({ serino: "", code: "", ip: "" });
  };

  const rows = [
    createData("Seri No", initialState.serino),
    createData("Dolum Yapılan Kooperatif", initialState.product),
    createData("Ambalaj Boyutu (gr)", initialState.dimensions),
    createData("Dolum Yeri", initialState.productPalace),
    createData(
      "Dolum Tarihi",
      initialState.productDate
        ? moment(initialState.productDate).format("DD.MM.YYYY")
        : ""
    ),
  ];

  useEffect(() => {
    if (queryLog) {
      const x = _.sortBy(queryLog, ["createdAt"], ["desc"]);
      x.splice(-1, 1);
      setInquiry(x);
    }
  }, [queryLog]);

  return (
    <Container maxWidth="sm">
      <CssBaseline />
      <Paper className={classes.paper} elevation={2}>
        <Grid container direction="row" justify="flex-end" alignItems="center">
          <span>
            <Tooltip title={"Yeni Sorgu"}>
              <IconButton onClick={handleClick}>
                <CachedIcon />
              </IconButton>
            </Tooltip>
          </span>
        </Grid>
        <Table aria-label="simple table">
          <TableBody>
            {rows.map((row, index) => (
              <TableRow key={index}>
                <TableCell component="th" scope="row">
                  {row.name}
                </TableCell>
                <TableCell>{row.value}</TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>

        {inquiry.length > 0 ? (
          <Grid
            className={classes.records}
            container
            direction="row"
            justify="center"
            alignItems="center"
          >
            <Typography
              align="center"
              component="h1"
              variant="h5"
              color="secondary"
            >
              {
                "Bu ürün daha önce sorgulanmıştır. Sorgulama tarihi, satınaldığınız tarihden önce ise fişiniz ile birlikte bayiye başvurunuz."
              }
            </Typography>
            <Table aria-label="simple table">
              <TableHead>
                <TableRow>
                  <TableCell align="center">Sorulama Tarihi</TableCell>
                  <TableCell align="center">Sorgulayan İp</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {inquiry.map((row, index) => (
                  <TableRow key={index}>
                    <TableCell align="center" component="th" scope="row">
                      {moment(row.createdAt).format("DD.MM.YYYY - HH:MM:SS")}
                    </TableCell>
                    <TableCell align="center">{row.ip}</TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </Grid>
        ) : (
          <Grid
            className={classes.records}
            container
            direction="row"
            justify="center"
            alignItems="center"
          >
            <Typography
              align="center"
              component="h1"
              variant="h5"
              color="primary"
            >
              {"Bu ürün daha önce sorgulanmamıştır."}
            </Typography>
          </Grid>
        )}
      </Paper>
    </Container>
  );
}
